/* eslint-disable react-hooks/exhaustive-deps */
import { Form, Input, Select } from "antd";
import { useRef } from "react";
import CaretDownIcon from "../../../../../assets/icons/CaretDownIcon";
import { useCheckKeyAvailabilityMutation } from "../../../../../features/superAdmin/ticketService/template/template.api";
import { TemplateStepProps } from "../../../../../types/template.types";
import { TEMPLATE_TYPES } from "../../constants/ticket.constants";

const TEMPLATE_TYPE_OPTIONS = [
  {
    value: TEMPLATE_TYPES.workflow,
    label: "Workflow Based",
  },
  {
    value: TEMPLATE_TYPES.sla,
    label: "SLA Based",
  },
];

const GeneralInfo = ({
  form,
  templateKey,
}: TemplateStepProps & { templateKey?: string }) => {
  // Component refs
  const debounceRef = useRef<any>(null);

  // Mutations
  const [checkKeyAvailability] = useCheckKeyAvailabilityMutation();

  // Watched values
  const templateRoles = form.getFieldValue("ticket_roles");

  return (
    <div className="p-6 shadow rounded-lg">
      <Form layout="vertical" form={form} requiredMark={false}>
        <Form.Item
          label="Template Name"
          name="name"
          rules={[{ required: true, message: "Template name is required" }]}
        >
          <Input size="large" placeholder="Enter template name" />
        </Form.Item>

        <div className="grid grid-cols-2 gap-4">
          <Form.Item
            label="Template Key"
            name="template_key"
            rules={[
              { required: true, message: "Template key is required" },
              { min: 2, message: "Template key must be at least 2 characters" },
              {
                validator: (_, value) =>
                  new Promise((resolve, reject) => {
                    if (
                      !value ||
                      value.length < 2 ||
                      value.toLowerCase() === templateKey?.toLowerCase()
                    ) {
                      return resolve(undefined);
                    }

                    // Clear previous debounce
                    if (debounceRef.current) {
                      clearTimeout(debounceRef.current);
                    }

                    debounceRef.current = setTimeout(async () => {
                      try {
                        const res = await checkKeyAvailability({
                          template_key: value,
                        }).unwrap();
                        if (res?.data?.exists) {
                          reject("Template key already exists");
                        } else {
                          resolve(undefined);
                        }
                      } catch (error) {
                        reject("Validation failed, try again");
                      }
                    }, 500); // 500ms debounce
                  }),
              },
            ]}
          >
            <Input size="large" placeholder="Enter template Key" />
          </Form.Item>
          <Form.Item
            label="Category"
            name="category"
            rules={[{ required: true, message: "Category is required" }]}
          >
            <Select
              size="large"
              placeholder="Select"
              suffixIcon={<CaretDownIcon />}
              options={[
                {
                  label: "General",
                  value: "general",
                },
                {
                  label: "Product",
                  value: "product",
                },
              ]}
            />
          </Form.Item>
        </div>

        <div>
          <Form.Item
            label="Type"
            name="type"
            rules={[{ required: true, message: "Type is required" }]}
          >
            <Select
              size="large"
              placeholder="Select type"
              suffixIcon={<CaretDownIcon />}
              options={TEMPLATE_TYPE_OPTIONS}
              onChange={() =>
                form.setFieldValue("ticket_roles", [templateRoles?.[0]])
              }
            />
          </Form.Item>
        </div>
      </Form>
    </div>
  );
};

export default GeneralInfo;
